import React from 'react';

import { CreatorSliderContentfulModel } from '../../api/models/CreatorsSlider';
import Heading from '../../elements/typography/heading';
import CreatorImages from '../../molecules/creators/creators.images';
import { CreatorsBackground, CreatorsContainer } from './creators.styles';
import CreatorsConfetti from 'organisms/creators/creators.confetti'
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';


export interface CreatorsProps {
  title: string;
  creators: CreatorSliderContentfulModel['contentfulchildren']
}

const Creators = ({ title, creators }: CreatorsProps): JSX.Element => {
  return (
    <CreatorsBackground>
      <CreatorsConfetti />
      <CreatorsContainer>
        <FadeInAnimationWrapper>
          <Heading
            text={title}
            size="2.5em"
            sizeLg="2em"
            sizeSubLg="1.5em"
            sizeXs="1.25em"
            weight="normal"
            align="center"
          />
        </FadeInAnimationWrapper>
        <CreatorImages
          creators={creators}
        />
      </CreatorsContainer>
    </CreatorsBackground>
  )
}

export default Creators;
